import { alpha } from "@mui/material";

const useStyles = (theme) => ({
  //ModalFilterMobile
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    padding: 2,
    maxWidth: "432px",
    width: "90%",
    minWidth: "232px",
    maxHeight: "90vh",
    gap: 2,
    flexDirection: "column",
    display: "flex",
    alignItems: "flex-start",
    //backgroundColor: "red",
  },
  dialogTitle: { padding: 0 },
  boxHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    color: "primary.main",
    width: "100%",
  },
  dialogContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 0,
    gap: 1.5,
  },
  boxRowFields: {
    display: "flex",
    flexDirection: "column",
    with: "100%",
    gap: 1,
  },
  labels: {
    fontSize: "14px",
    fontWeight: 500,
    color: "text.primary",
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    gap: 0,
    padding: 0,
    width: "100%",
  },
  button: { width: "50%" },
  iconTextFields: { color: "text.secondary", fontSize: "18px" },
  //Filters
  containerButtonFilter: {
    display: { xs: "flex", md: "none" },
  },
  backgroundBox: {
    display: "flex",
    flexDirection: "row",
    //backgroundColor: theme.palette.background.textField,

    gap: 1.5,
    //padding: { xs: 0, sm: "8px 4px 4px 4px", md: "4px 4px 4px 8px" },
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    display: { xs: "none", md: "flex" },
  },
  boxTitle: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
    width: "100%",
    flexDirection: "row",
    gap: 0.5,
  },
  text: {
    fontSize: "14px",
    fontWeight: 500,
    //height: "20px",
  },
  paperBrick: {
    display: "flex",
    borderRadius: "7px",
    padding: "10px",
    flexDirection: "row",
    justifyContent: "center",

    alignItems: "center",
    paddingLeft: 1.5,
    width: { xs: "100%", md: "fit-content" },

    gap: 0.5,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: alpha(theme.palette.background.paper, 0.7),
    },
  },
  size: { fontSize: 20 },
  paperDrawer: {
    ".MuiDrawer-paper": {
      borderRadius: "0px",
      width: "90%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: alpha(theme.palette.background.default, 0.99),
      padding: 1.5,
      gap: 2,
    },
  },
  buttonClearFilters: {
    height: "32px",
    color: "text.primary",
    width: { xs: "100%", md: "fit-content" },
  },
  buttonSearch: {
    width: { xs: "100%", md: "fit-content" },
    borderRadius: "4px",
    height: "38px",
    color: "white",
    backgroundColor: theme.palette.easyLog.primary,
    // quanto estive desabilitadi
    "&.Mui-disabled": {
      backgroundColor: alpha(theme.palette.easyLog.primary, 0.1),
    },
  },
  // sizeGridItem: { xs: 12, md: "auto" },
  sizeGridItem: "auto",
  buttonMobile: { display: { xs: "flex", md: "none" } },
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "primary.main",
      color: "#FFFFFF",
      margin: 1,
      boxShadow: "0px 3px 3px #00000052",
      top: -25,
      right: -15,
    },
  },
  buttonFilterMobile: {
    p: 1.3,
    minWidth: 0,
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color: "primary.main",
    display: { xs: "flex", md: "none" },
  },
  checkBox: {
    color: theme.palette.easyLog.secondary,
    "&.Mui-checked": {
      color: theme.palette.easyLog.primary,
    },
    p: "0px",
  },
  button: {
    fontSize: "13px",
    flexWrap: "no-wrap",
    minWidth: "160px",
    width: { xs: "100%", md: "160px" },
    height: "40px",
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color: "primary.main",
    display: { xs: "none", md: "flex" },
  },
  textDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    fontColor: theme.palette.text.primary,
  },
  titleDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.shadow,
  },
  dataTime: {
    actionBar: {
      actions: ["accept"],
      sx: {
        "& .MuiButton-root": {
          color: theme.palette.easyLog.primary, // Cor do texto
          backgroundColor: "transparent", // Cor de fundo
          "&:hover": {
            backgroundColor: alpha(theme.palette.easyLog.primary, 0.05), // Cor de fundo ao passar o mouse
          },
        },
      },
    },
    accept: {
      sx: {
        backgroundColor: "#4CAF50", // Cor verde para o botão Aceitar
        color: "white",
        "&:hover": {
          backgroundColor: "#45a049", // Cor verde mais escuro no hover
        },
        borderRadius: "5px",
      },
    },
    digitalClockSectionItem: {
      sx: {
        borderRadius: "4px",
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    day: {
      sx: {
        "&.Mui-selected:focus": {
          backgroundColor: theme.palette.easyLog.primary, // Mantém a cor ao clicar
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
          fontWeight: 500,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    desktopPaper: {
      sx: {
        backgroundColor: theme.palette.background.default,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para desktop
    mobilePaper: {
      sx: {
        backgroundColor: theme.palette.background.paperNotification,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para mobile
  },
  datePicker: {
    "& .MuiButton-root": { backgroundColor: "purple" }, // Cor dos botões do pop-up
    "& .MuiPickersDay-root": { "&::selected": { backgroundColor: "blue" } }, // Cor dos dias no calendário
    "& .Mui-selected": { backgroundColor: "red!important" }, // Cor do dia selecionado
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "blue" }, // Cor da borda padrão
      "&:hover fieldset": { borderColor: "red" }, // Cor da borda ao passar o mouse
      "&.Mui-focused fieldset": { borderColor: "green" }, // Cor ao focar
    },
    "& .MuiInputLabel-root": { color: "purple" }, // Cor do label
    "& .MuiInputLabel-root.Mui-focused": { color: "green" }, // Cor do label ao focar
  },
  stackOption: {
    flexDirection: "row",
    width: "100%",
    p: "5px",
    alignItems: "center",
  },
  textoLimitado: {
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limita o texto a 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  menuItem: {
    fontSize: "0.875rem",
    fontWeight: 500,

    "&.Mui-selected": {
      borderRadius: "4px",
      background: theme.palette.easyLog.primary,
      color: "white",
      "&:hover": {
        background: alpha(theme.palette.easyLog.primary, 0.8),
      },
    },
  },
  paperPoover: {
    "& .MuiPopover-paper": {
      marginTop: "5px",
      boxShadow: "0px 4px 14px 0px  #0000002c",
      padding: "10px",
      overflow: "visible",
    },
  },
  disable: {
    opacity: 0.6,
    pointerEvents: "none",
  },
});

export default useStyles;
